// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sort-by-arrow{float:right;margin-right:1rem}.sort-by-arrow:hover{cursor:pointer}", ""]);
// Exports
module.exports = exports;
